import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
// import Alert from 'react-bootstrap/Alert';
import _ from 'lodash';
import auth from './auth';
import { getSessionCookie, setSessionCookie } from './session';
import { submitCodeRequest, getUserInfo, getAppInfo } from './thunks';
import { sendLoginSuccess, sendLoginFailure } from './actions';
import { setLoginInfo } from './actions';
import { getUrlParams, debounce } from './util';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AppLogin.css';

const AppLogin = ({ appInfo, userInfo, loginInfo, sendCode, sendLogin, startGetAppInfo, 
  startGetUserInfo, startSetLoginInfo, startSendLoginSuccess, startSendLoginFailure }) => {
  
  const history = useHistory();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/" } };
  
  let params = getUrlParams(location.state && location.state.from && location.state.from.search);
  let userId = params['user'];
  
  const session = getSessionCookie({ userId:userId });
  if(session && session.username) {
    history.replace(from);
  }
  
  useEffect(() => {
    startGetAppInfo();
    if (userId) {
      startGetUserInfo({userId});
    }
  }, [startGetAppInfo, startGetUserInfo, userId]);
  
  const handleLogin = (event) => {
    event.preventDefault();
    let code = document.getElementById('code').value;
    let passwordElement = document.getElementById('password');
    let password = passwordElement && passwordElement.value;
    // console.log('>>> userInfo.userId:', userInfo.userId);
    const data = { 
      username: userInfo.userId, 
      password: password, 
      code: code
    };
    // console.log('>>> handleLogin data:', data);
    auth.authenticate(data, (error, result) => {
      let resultMessage = result && result.data;
      if (result && result.status === 200) {
        console.log('authentication passed:', resultMessage);
        let config = _.assign({}, userInfo, appInfo);
        setSessionCookie(result.config.data, config, () => {
          // console.log('>>> login success - from:', from);
          if (!from.search) {
            from.search = '?user=' + userInfo.userId;
          }
          // console.log('>>> login success - from:', from);
          history.replace(from);
        });
        startSendLoginSuccess({ loginStatus:'login is successfully' });
      } else {
        console.log('authentication failed:', error && error.message);
        startSendLoginFailure({ loginStatus:error && error.message });
      }
    });
  };
  
  const handleSendCode = (event) => {
    event.preventDefault();
    let type = loginInfo.smsChecked ? 'sms' : (loginInfo.emailChecked ? 'email' : '');
    let data = { type:type, userId:userInfo.userId, userType:userInfo.userType };
    data.value = (type === 'sms') ? userInfo.mobilePhone : userInfo.emailAddress;
    sendCode(data);
  };
  
  const changeToSendBySms = (event) => {
    console.log('changeToSendBySms');
    startSetLoginInfo({ smsChecked:true, emailChecked:false });
  };
  
  const changeToSendByEmail = (event) => {
    console.log('changeToSendByEmail');
    startSetLoginInfo({ smsChecked:false, emailChecked:true });
  };
  
  const changeUsername = (event) => {
    let userId = event.currentTarget.value || '';
    userId = userId.toLowerCase();
    console.log('changeUsername userId:', event.currentTarget.value);
    // startSetLoginInfo({ smsChecked:true, emailChecked:false });
    startGetUserInfo({userId});
  };
  
  const getDisabledValue = (user, type) => {
    let result = true;
    if (type === 'phone') {
      result = !user.mobilePhone;
    } else if (type === 'email') {
      result = !user.emailAddress;
    } else {
      result = false;
    }
    if (!user.isActive) {
      result = true;
    }
    return result;
  };
  
  const getSendDisabledValue = (user = {}) => {
    let result = true;
    if (user.emailAddress || user.mobilePhone) {
      result = false;
    }
    if (!user.isActive) {
      result = true;
    }
    return result;
  };
  
  const getHintMessage = (user) => {
    let result = '';
    if (!user.hasOwnProperty('isActive')) {
      return '';
    }
    if (!user.isActive) {
      result = 'Sorry, you are no longer an active BPS user. ' + 
        'Please contact your BPS Administrator.';
    } else if (!user.emailAddress && !user.mobilePhone) {
      result = 'You don’t have mobile number or email on record. ' + 
        'Please contact your BPS administrator.';
    }
    return result;
  };
  
  const getPasswordReseturl = (user) => {
    return `/user/password/reset?userId=${user.userId}`;
  };
  
  return (
    <div className="AppHome">
      <br /><br />
      <Container>
        <Row>
          <Col></Col>
          <Col xs={4}>
            <Form className="loginForm" onSubmit={handleLogin}>
              <br/>
              <h2>BPS Review Portal</h2>
              <br/>
              <Form.Group controlId="formUsername">
                <div className="username-container">
                  <Form.Label>Username</Form.Label>
                  <Form.Control type="text" value={userId} 
                    onChange={ changeUsername }/>
                </div>
                { appInfo.require_password > 0 && 
                <div className="password-container">
                  <Form.Label>Password</Form.Label>
                  <Form.Control id="password" type="password" />
                  <Form.Text className="text-muted">
                    <a href={ getPasswordReseturl(userInfo) } target="_new">Reset password</a>
                  </Form.Text>
                </div>
                }
              </Form.Group>
              <Form.Group controlId="formType">
                <Form.Label>Send verfication code to </Form.Label>
                <br/>
                <Form.Check type="radio" id="SMS" label="SMS" name="type" inline 
                  value={ userInfo && userInfo.mobilePhone } 
                  disabled={ getDisabledValue(userInfo, 'phone') }
                  checked={ loginInfo.smsChecked }
                  onChange={ changeToSendBySms }/>
                <Form.Check type="radio" id="Email" label="Email" name="type" inline 
                  value={ userInfo && userInfo.emailAddress } 
                  disabled={ getDisabledValue(userInfo, 'email') }
                  checked={ loginInfo.emailChecked }
                  onChange={ changeToSendByEmail }  />
                <Button variant="info" size="sm" onClick={handleSendCode} 
                  disabled={ getSendDisabledValue(userInfo) } >
                  Send
                </Button>
                <Form.Text className="text-danger">
                  { getHintMessage(userInfo) }
                </Form.Text>
                <Form.Text className="text-info">
                  { loginInfo.infoSendStatus }
                </Form.Text>
              </Form.Group>
              <Form.Group>
                <Form.Label>Enter code</Form.Label>
                <Form.Control id="code" type="text" placeholder="verification code" 
                  disabled={ getDisabledValue(userInfo, '') }/>
              </Form.Group>
              <input type="submit" className="btn btn-info btn-login" 
                value="Log in" disabled={ getDisabledValue(userInfo, '') } />
              <input type="button" className="btn btn-info btn-cancel" 
                value="Cancel" disabled={ getDisabledValue(userInfo, '') }/>
              <Form.Text className="text-danger">
                { loginInfo.loginStatus }
              </Form.Text>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </div>
  );
}

const mapState = state => ({
  userInfo: state.userInfo,
  loginInfo: state.loginInfo,
  appInfo: state.appInfo,
})

const mapDispatch = dispatch => ({
  sendCode: (data) => dispatch(submitCodeRequest(data)),
  startGetUserInfo: (data) => dispatch(getUserInfo(data)),
  startSetLoginInfo: (data) => dispatch(setLoginInfo(data)),
  startGetAppInfo: (data) => dispatch(getAppInfo(data)),
  startSendLoginFailure: (data) => dispatch(sendLoginFailure(data)),
  startSendLoginSuccess: (data) => dispatch(sendLoginSuccess(data)),
})

export default connect(mapState, mapDispatch)(AppLogin);
